module.exports = __webpack_public_path__ + "img/invite.40041b7d.png";